exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Discussion-ModalText-Root {\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  white-space: pre-wrap;\n}\n.Discussion-ModalText-Root[data-color=\"danger\"] {\n  color: #f00;\n}\n", ""]);

// exports
